import styled from '@emotion/styled';
import { typography } from 'src/theme/typography';
import { media } from 'src/theme/breakpoints';

const TransferCardStyle = styled('div')`
    position: relative;

    &.edit {
        border: 2px solid var(--orange-300);
    }

    .iconAddComment {
        position: absolute;
        right: 0;
        top: 50%;
        margin-right: -25px;
        margin-top: -25px;
        cursor: pointer;
        transition: all 0.2s;
        z-index: 1;
        &:hover {
            transform: scale(1.1);
        }
    }
    .item-flight {
        ${typography.bodyXs}
        color: var(--sand-600);
        .icon-detail {
            color: var(--orange-300);
            margin-top: 4px;
        }
        .location {
            margin-bottom: 8px;
        }
    }

    ${media.mobile} {
        &&.card {
            padding: 24px;
        }
    }
`;

export default TransferCardStyle;
